import React from 'react';
import { Tag } from 'antd';
import BaseTag from '../../_ui/BaseTag/BaseTag';

function RobotActorTag({ isRobot }) {
  return isRobot && <BaseTag className="ml-2" color="volcano">ROBOT</BaseTag>;
}

export default RobotActorTag;
